import { SportConfigExport } from './';
import {
	$t,
	singleStepOverview,
	singleStepCompetition,
	singleStepEvent,
	singleStepTeam,
	getCompetitorsParams,
} from './singleStepContexts';

import { SportPageType } from '@/features/sports/types/interfaces';
import { SingleStepSportEvent, SportType } from '@/@types/graphql-types';
import { WebLocale } from '@/enums/web-locale';

/* CONSTANTS */
const sportName = $t('SPORTS_WEBAPP_SPORT_TYPE_RUGBY');
const switchedLocales = [WebLocale.us, WebLocale.ca];

function getCompetitors(event: SingleStepSportEvent) {
	return getCompetitorsParams(event);
}

/* CONTEXTS */
function overview() {
	const { getEventTitleParams, ...rest } = singleStepOverview(SportType.Rugby);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		headline: $t('SPORTS_WEBAPP_OVERVIEW_HEADLINE_RUGBY'),
		subheading: $t('SPORTS_WEBAPP_OVERVIEW_TEXT_RUGBY'),
		getCompetitors,
		...singleStepOverview(SportType.Rugby),
		...rest,
	};
}

function competition() {
	const { getEventTitleParams, ...rest } = singleStepCompetition(SportType.Rugby);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		getCompetitors,
		...singleStepCompetition(SportType.Rugby),
		...rest,
	} as const;
}

function event() {
	const { getEventTitleParams, ...rest } = singleStepEvent(SportType.Rugby);

	function getEventTitle(event: SingleStepSportEvent) {
		return getEventTitleParams(event);
	}

	return {
		sportName,
		getEventTitle,
		getCompetitors,
		...rest,
	};
}

function team() {
	const { getEventTitleParams, ...rest } = singleStepTeam(SportType.Rugby);

	function getEventTitle(event: SingleStepSportEvent) {
		return getEventTitleParams(event);
	}

	return {
		sportName,
		getEventTitle,
		getCompetitors,
		...rest,
	};
}

/* EXPORTS */
const config: SportConfigExport = {
	[SportPageType.SportOverview]: overview,
	[SportPageType.SportCompetition]: competition,
	[SportPageType.SportEvent]: event,
	[SportPageType.SportTeam]: team,
};

export default config;
